import { render, staticRenderFns } from "./Medications.vue?vue&type=template&id=5aab4a2b&"
import script from "./Medications.vue?vue&type=script&lang=js&"
export * from "./Medications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports